/**
 * Better Auth React client — single instance shared across the SPA.
 * baseURL points at the NestJS API; Better Auth mounts under /api/auth by default.
 * AUTH_BASE_PATH from @system/shared keeps the basePath in sync with the API.
 */
import { createAuthClient } from 'better-auth/react'
import { AUTH_BASE_PATH } from '@system/shared'

export const authClient = createAuthClient({
  baseURL: import.meta.env.VITE_API_URL,
  basePath: AUTH_BASE_PATH,
})
